export default __webpack_public_path__ + "static/media/logoExtended.e8837eff.png";